/** @returns {{ valid: boolean, message: string | null }} */
export const getDateRangeValidation = (fromDate, toDate) => {
  if (!fromDate || !toDate) {
    return { valid: false, message: null };
  }

  const startDate = new Date(fromDate);
  const endDate = new Date(toDate);
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  if (startDate < currentDate) {
    return { valid: false, message: "Start date cannot be in the past." };
  }

  if (endDate <= startDate) {
    return { valid: false, message: "End date should be after the start date." };
  }

  const numberOfDays = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));

  if (numberOfDays < 14) {
    return { valid: false, message: "The minimum stay is 14 days." };
  }

  return { valid: true, message: null };
};

export const validateDateRange = (fromDate, toDate, enqueueSnackbar) => {
  if (!fromDate || !toDate) {
    enqueueSnackbar("Please select both start and end dates.", { variant: "error" });
    return false;
  }

  const { valid, message } = getDateRangeValidation(fromDate, toDate);
  if (!valid) {
    enqueueSnackbar(message || "Invalid date range.", { variant: "error" });
    return false;
  }

  return true;
};
